
import { Component, Vue } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import { getOrgInfoByOId, logout, updatePassword } from '@/api/login'
import { template } from '@/router/modules/template'
import { Service } from '@/router/modules/serviceList'
import { myOrders } from '@/router/modules/myOrders'
@Component({
  name: 'Navbar',
  components: {},
})
export default class extends Vue {
  @Getter('user') getUser: any
  @Action('setUser') setUser: any
  @Getter('routers') getRouters: any
  // 计算属性
  get orgId() {
    return this.$store.state.user?.orgs[0]?.orgId || 0
  }

  // 添加计算属性判断是否处于折叠模式
  get isCollapsed() {
    return window.innerWidth <= 768
  }
  orgInfo: any = {}
  entries: number[] = []

  get RoutersData() {
    if (this.entries.includes(10)) {
      template.find((item: any) => item.path === '/template_stu2tea')!.hidden = false
    }
    // todo:需要优化过滤条件
    if (this.getUser?.orgs?.[0]?.isAdmin != 1 && this.getUser?.orgs?.[0]?.isOwner != 1) {
      Service.find((item: any) => item.path === '/service')!.hidden = true
      return Service.concat(myOrders)
    }
    // todo:特殊处理万唯客户
    if (this.entries.some(item => [30,31].includes(item)) && [503, 506].includes(this.getUser?.orgs?.[0]?.orgId)) {
      Service.find((item: any) => item.path === '/service')!.hidden = true
      return Service.concat(myOrders)
    }
    let subMenuItems = Service.concat(myOrders).concat(template)
    return subMenuItems
  }

  // 判断来源域名
  get isFromExternalDomain() {
    // 获取当前域名
    const currentDomain = process.env.VUE_APP_AI_HOST;
    const currentHostname = window.location.hostname;
    // 如果来源域名为空或与当前域名相同，则认为是从本域名跳转
    return currentHostname && currentHostname === currentDomain;
  };

  async created() {
    if (!this.orgId) {
      return
    }
    if (!this.$store.state.OrgInfo) {
      this.orgInfo = await getOrgInfoByOId({ orgId: this.orgId })
      this.$store.commit('SET_ORGINFO', this.orgInfo)
    } else {
      this.orgInfo = this.$store.state.OrgInfo
    }
    this.entries = this.orgInfo.entries.split(',').map((item: string) => Number(item))
  }

  // 监听窗口大小变化
  mounted() {
    window.addEventListener('resize', this.handleResize)
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize() {
    // 强制更新组件
    this.$forceUpdate()
  }

  get avatar() {
    return require('@/assets/avatar.gif')
  }

  get nickname() {
    if (this.getUser) {
      return this.getUser.nickname
    }
    return ''
  }

  public async logout() {
    await logout()
    window.location.replace('signin.html')
    this.setUser(null)
  }
  async goPortal() {
    window.location.replace('signin.html')
  }

  dialogVisible = false
  dialogForm = {
    oldPassword: '',
    newPassword: '',
    reNewPassword: '',
  }
  async handleUpdatePassword() {
    if (!this.dialogForm.oldPassword || !this.dialogForm.newPassword || !this.dialogForm.reNewPassword) {
      this.$message.error('请填写完整信息')
      return
    }
    if (this.dialogForm.newPassword !== this.dialogForm.reNewPassword) {
      this.$message.error('两次输入的密码不一致')
      return
    }
    try {
      await updatePassword({
        oldPassword: this.dialogForm.oldPassword,
        newPassword: this.dialogForm.newPassword,
      })
      this.$message.success('修改成功,请重新登录')
      this.logout()
    } catch (e) {
      this.$message.error((e as any).statusInfo)
    }
  }
}
